import React from 'react';
import './Error.style.scss';
import IconButton from '#/components/form/IconButton/IconButton';

interface IProps {
  message: string;
  handleOnClose: () => void;
}

const Error = ({ message, handleOnClose }: IProps) => {
  return (
    <div className="error">
      <div className="error--message">
        <span>{message}</span>

        <IconButton icon="close" type="danger" handleOnClick={handleOnClose} />
      </div>
    </div>
  );
};

export default Error;
